import styled from "styled-components";

export const CopySoreWrap = styled.div`
    .heading {
        display: block;
        margin-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 400;
        color: #313131;
    }
    .inputHolder {
        border-bottom: 1px solid #d1d1d1;
        margin-bottom: 20px;
    }
    .branches {
        background-color: #cdcdcd;
        padding: 20px;
        border-radius: 15px;
        margin-bottom: 20px;
        div {
            margin: 0;
            label {
                margin: 0;
            }
        }
    }
    .btn-holder {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .title {
        color: var(--text-color);
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 16px;
    }

    .options-wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        .input-field-wrap {
            max-width: max-content;
        }
    }

    .categories-wrap {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
        padding: 20px 15px 10px;
        background: rgba(245, 126, 42, 0.1);
        border-radius: 20px;
        border: 1px solid rgba(245, 126, 42, 0.15);
        margin-bottom: 20px;
        .input-field-wrap {
            max-width: max-content;
        }
    }

    .items-wrap {
        padding: 20px 15px 10px;
        background: rgba(245, 126, 42, 0.1);
        border-radius: 20px;
        border: 1px solid rgba(245, 126, 42, 0.15);
        margin-bottom: 20px;
        .item {
            transition: all 0.3s ease-in-out;
            .head {
                display: flex;
                align-items: center;
                gap: 13px;
                margin-bottom: 18px;
                cursor: pointer;
                .arrowIcon {
                    transition: all 0.2s ease-in-out;
                }
            }
            .sub-items {
                display: none;
                flex-wrap: wrap;
                gap: 21px;
                padding-left: 22px;
                opacity: 0;
                transition: all 0.3s ease-in-out;
                .input-field-wrap {
                    max-width: max-content;
                }
            }
            &.active {
                .sub-items {
                    display: flex;
                    opacity: 1;
                }
                .head > .arrowIcon {
                    rotate: 90deg;
                }
            }
        }
    }

    .separator {
        border-bottom: 1px solid rgba(233, 233, 233, 1);
        margin-bottom: 15px;
    }

    .details {
        list-style: none;
        margin-bottom: 40px;
        li {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            margin-bottom: 15px;
            .name {
                color: rgba(143, 143, 143, 1);
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
            }
            .value {
                color: var(--text-color);
                font-size: 16px;
                line-height: 20px;
                font-weight: 400;
            }
        }
    }
`;
